import Hero from './Hero.json'
import LoveInclusion from './LoveInclusion.json'
import Pilars from './Pilars.json'
import Mantras from './Mantras.json'
import Offices from './Offices.json'
import Socials from './Socials.json'
export default {
  Hero,
  LoveInclusion,
  Pilars,
  Mantras,
  Offices,
  Socials,
}
